import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { Photographer } from 'src/app/models/common/photographer.models';
import { map } from 'rxjs';
import { Selectable } from 'src/app/shared/models/types/selectable.type';
import { PhotographerQueries } from 'src/app/models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';

@Injectable({
  providedIn: 'root'
})
export class PhotographerFilterService extends IFilterListService<Photographer> {

  search(searchText: string, variables): void {
    this.graphQlService.getData<Photographer>(PhotographerQueries.GET_PHOTOGRAPHERS, { search: searchText, companyId: Number(this.appService.companyId), paginationPage: variables.page, paginationSize: variables.size, statusIds: [] })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['photographers'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<Photographer>) => {
          const datasource: Array<Selectable<Photographer>> = res.nodes.map(el => ({ ...el, displayId: el.personId!, displayName: el.fullName!, disabled: false, selected: false }));
          this.datasource.next(datasource);
        }
      })
  }
}
